import React, { useState } from 'react';
import axios from 'axios';

function AddDeviceForm({ onDeviceAdded }) {
    const initialState = {
        producent: '',
        model: '',
        typ_systemu: 'Split',
        rodzaj_urzadzenia: 'Ścienny',
        szerokosc_mm: '',
        wysokosc_mm: '',
        glebokosc_mm: '',
        waga_kg: '',
        halas_db: '',
        moc_chlodnicza_kw: '',
        moc_grzewcza_kw: '',
        pobor_pradu_kw: '',
        seer: '',
        scop: ''
    };
    const [formData, setFormData] = useState(initialState);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        // Basic validation (can be expanded)
        for (const key in formData) {
            if (formData[key] === '' && key !== 'szerokosc_mm' && key !== 'wysokosc_mm' && key !== 'glebokosc_mm' && key !== 'waga_kg' && key !== 'halas_db' && key !== 'moc_chlodnicza_kw' && key !== 'moc_grzewcza_kw' && key !== 'pobor_pradu_kw' && key !== 'seer' && key !== 'scop') {
                // Allow optional fields to be empty, but core fields must be filled
                if(['producent', 'model', 'typ_systemu', 'rodzaj_urzadzenia'].includes(key)){
                    setError(`Pole ${key} jest wymagane.`);
                    return;
                }
            }
        }
        
        // Convert empty strings for numeric fields to null or handle as needed by backend
        const dataToSubmit = { ...formData };
        for (const key in dataToSubmit) {
            if (['szerokosc_mm', 'wysokosc_mm', 'glebokosc_mm', 'waga_kg', 'halas_db', 'moc_chlodnicza_kw', 'moc_grzewcza_kw', 'pobor_pradu_kw', 'seer', 'scop'].includes(key)) {
                if (dataToSubmit[key] === '') {
                    dataToSubmit[key] = null; // Or handle as 0 if appropriate, or skip if backend handles empty strings
                } else {
                    dataToSubmit[key] = parseFloat(dataToSubmit[key]);
                }
            }
        }

        try {
            const response = await axios.post("/devices", dataToSubmit);
            setSuccessMessage('Urządzenie dodane pomyślnie!');
            setFormData(initialState); // Reset form
            if (onDeviceAdded) {
                onDeviceAdded(); // Callback to refresh device list or perform other actions
            }
        } catch (err) {
            console.error("Błąd dodawania urządzenia:", err.response ? err.response.data : err.message);
            setError(err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Nie udało się dodać urządzenia. Sprawdź konsolę, aby uzyskać więcej informacji.');
            if (err.response && err.response.data && err.response.data.errors){
                let errorMessages = [];
                for(const field in err.response.data.errors){
                    errorMessages.push(`${field}: ${err.response.data.errors[field]}`);
                }
                setError(`Błędy walidacji: ${errorMessages.join(', ')}`);
            }
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{ border: '1px solid #ccc', padding: '20px', marginTop: '20px', marginBottom: '20px' }}>
            <h3>Dodaj nowe urządzenie</h3>
            {error && <p style={{ color: 'red' }}>{error}</p>}
            {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '10px' }}>
                <div>
                    <label>Producent: </label>
                    <input type="text" name="producent" value={formData.producent} onChange={handleChange} required />
                </div>
                <div>
                    <label>Model: </label>
                    <input type="text" name="model" value={formData.model} onChange={handleChange} required />
                </div>
                <div>
                    <label>Typ systemu: </label>
                    <select name="typ_systemu" value={formData.typ_systemu} onChange={handleChange}>
                        <option value="Split">Split</option>
                        <option value="MultiSplit">MultiSplit</option>
                        <option value="VRF">VRF</option>
                    </select>
                </div>
                <div>
                    <label>Rodzaj urządzenia: </label>
                    <select name="rodzaj_urzadzenia" value={formData.rodzaj_urzadzenia} onChange={handleChange}>
                        <option value="Ścienny">Ścienny</option>
                        <option value="Kasetonowy">Kasetonowy</option>
                        <option value="Podstropowy">Podstropowy</option>
                        <option value="Kanałowy">Kanałowy</option>
                    </select>
                </div>
                <div>
                    <label>Szerokość (mm): </label>
                    <input type="number" name="szerokosc_mm" value={formData.szerokosc_mm} onChange={handleChange} />
                </div>
                <div>
                    <label>Wysokość (mm): </label>
                    <input type="number" name="wysokosc_mm" value={formData.wysokosc_mm} onChange={handleChange} />
                </div>
                <div>
                    <label>Głębokość (mm): </label>
                    <input type="number" name="glebokosc_mm" value={formData.glebokosc_mm} onChange={handleChange} />
                </div>
                <div>
                    <label>Waga (kg): </label>
                    <input type="number" step="0.1" name="waga_kg" value={formData.waga_kg} onChange={handleChange} />
                </div>
                <div>
                    <label>Hałas (dB): </label>
                    <input type="number" step="0.1" name="halas_db" value={formData.halas_db} onChange={handleChange} />
                </div>
                <div>
                    <label>Moc chłodnicza (kW): </label>
                    <input type="number" step="0.1" name="moc_chlodnicza_kw" value={formData.moc_chlodnicza_kw} onChange={handleChange} />
                </div>
                <div>
                    <label>Moc grzewcza (kW): </label>
                    <input type="number" step="0.1" name="moc_grzewcza_kw" value={formData.moc_grzewcza_kw} onChange={handleChange} />
                </div>
                <div>
                    <label>Pobór prądu (kW): </label>
                    <input type="number" step="0.1" name="pobor_pradu_kw" value={formData.pobor_pradu_kw} onChange={handleChange} />
                </div>
                <div>
                    <label>SEER: </label>
                    <input type="number" step="0.1" name="seer" value={formData.seer} onChange={handleChange} />
                </div>
                <div>
                    <label>SCOP: </label>
                    <input type="number" step="0.1" name="scop" value={formData.scop} onChange={handleChange} />
                </div>
            </div>
            <button type="submit" style={{ marginTop: '20px' }}>Dodaj urządzenie</button>
        </form>
    );
}

export default AddDeviceForm;

